module.exports = __webpack_public_path__ + "img/about-us-header.dbae5d1f.jpg";